import * as React from 'react';
import { ArticleHeading1, UIText2 } from '@cian/ui-kit/typography';
import * as style from './Address.css';
import { Layout } from '../Layout';

interface IAddressProps {
  fullAddress: string;
  underground: React.ReactNode;
  roads: React.ReactNode;
  transportAccessibility: React.ReactNode;
  mapPreview: React.ReactNode;
}

export function Address({ fullAddress, underground, roads, transportAccessibility, mapPreview }: IAddressProps) {
  return (
    <Layout>
      <div className={style['container']}>
        <div>
          <UIText2 color={'text-secondary-default'}>Адрес</UIText2>
          <div className={style['full-address']}>
            <ArticleHeading1 data-testid="FullAddressHeading">{fullAddress}</ArticleHeading1>
          </div>
          <div className={style['stations']}>
            {underground}
            {roads}
          </div>
          <div className={style['transport-accessibility']}>{transportAccessibility}</div>
        </div>
        <div className={style['map']}>{mapPreview}</div>
      </div>
    </Layout>
  );
}
